/* CG props fix (R54, Oct 21 2026). Checkmate builds each Toast modifier from a line item property
   {Toast group name: Toast option name} and checks required groups against those properties.
   1. Every Shopify order that failed with "Required modifier ... is missing" had a "Special Instructions"
      line property somewhere in the order; orders with required groups and no such property went
      through (e.g. 3738, 3755, 3759). "Special Instructions" is not a Toast modifier group, so it is no
      longer sent as a line property. Each dish note is moved into the order note
      ("Country Club: no tomato"), which Checkmate passes to Toast as the order note.
   2. A second pick from the same group ("ENTREE SIDE (2)") is sent the way Checkmate documents for
      multi-select groups: one property, comma-separated values ("ENTREE SIDE": "Corn, Fruit").
   The note text is kept on the dish line as "_note" (underscore = hidden) only so Edit can reopen it. */
/* R60 (Oct 27 2026): Checkmate reads the Shopify VARIANT as the Toast modifier and ignores line item
   properties. Catering items tagged cm-variant-choices carry their required Toast groups as real Shopify
   options; the catering sheet still shows them as choices, and here the picked choices are turned into the
   matching variant id before the item goes into the cart. */
(function () {
  'use strict';
  var of = window.fetch; if (!of || of.__cgprops) return;
  var pending = [];
  /* Catering date: a date saved on an earlier visit that is already past made the picker say
     "No times left today" for an old day. Drop it before cg-catering.js (deferred) reads it. */
  function isPast(v) { var p = String(v || '').split('-'); if (p.length !== 3) return false; var d = new Date(+p[0], +p[1] - 1, +p[2]), t = new Date(); t.setHours(0, 0, 0, 0); return d < t; }
  try {
    var cs = JSON.parse(localStorage.getItem('cgc_order_v1') || 'null');
    if (cs && isPast(cs.date)) { cs.date = ''; cs.time = ''; localStorage.setItem('cgc_order_v1', JSON.stringify(cs)); }
  } catch (e) {}
  function fixItem(it, title) {
    var p = it && it.properties; if (!p || typeof p !== 'object') return;
    var multi = {};
    Object.keys(p).forEach(function (k) {
      var m = k.match(/^(.*) \((\d+)\)$/);
      if (m && p[k]) { (multi[m[1]] = multi[m[1]] || []).push(p[k]); delete p[k]; }
    });
    Object.keys(multi).forEach(function (g) {
      var vals = (p[g] ? [p[g]] : []).concat(multi[g]);
      p[g] = vals.join(', ');
    });
    var nk = p['Special Instructions'] != null ? 'Special Instructions' : (p['Special instructions'] != null ? 'Special instructions' : null);
    var note = nk ? p[nk] : null;
    if (nk) {
      delete p[nk];
      note = String(note).trim();
      if (note) { p._note = note; pending.push((title || 'Item') + ': ' + note); }
    }
  }
  function swapVariant(it) {
    try {
      var p = it && it.properties; if (!p) return;
      var all = document.querySelectorAll('script[data-cgc-product]');
      for (var i = 0; i < all.length; i++) {
        var j = JSON.parse(all[i].textContent);
        if (!j.allv || !j.onames) continue;
        if (!j.allv.some(function (v) { return +v.id === +it.id; })) continue;
        var hit = j.allv.filter(function (v) { return j.onames.every(function (n, k) { return p[n] == null || v.opts[k] === String(p[n]); }); })[0];
        if (hit) it.id = hit.id;
        return;
      }
    } catch (e) {}
  }
  function titleFor(it) {
    try {
      var all = document.querySelectorAll('script[data-cgm-product], script[data-cgc-product]');
      for (var i = 0; i < all.length; i++) {
        var j = JSON.parse(all[i].textContent);
        if ((j.variants || []).concat(j.allv || []).some(function (v) { return +v.id === +it.id; })) return j.title;
      }
    } catch (e) {}
    return '';
  }
  function flushNotes() {
    if (!pending.length) return Promise.resolve();
    var add = pending.splice(0);
    return of.call(window, '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var cur = (cart.note || '').trim();
      var lines = cur ? cur.split('\n') : [];
      add.forEach(function (l) { if (lines.indexOf(l) < 0) lines.push(l); });
      return of.call(window, '/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: lines.join('\n').slice(0, 1000) }) });
    }).catch(function () {});
  }
  /* Read-back for the theme's own scripts: /cart.js GET responses show the dish note again as
     "Special Instructions" and a comma list as numbered picks, so Edit reopens the dish as ordered.
     Only the copy handed to theme JS changes; the cart and the order keep the Checkmate format. */
  function isCartRead(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var m = (init && init.method) || (input && input.method) || 'GET';
    return /\/cart(\.js)?(\?|$)/.test(url) && String(m).toUpperCase() === 'GET';
  }
  function readBack(r) {
    if (!r || !r.ok) return r;
    return r.clone().json().then(function (cart) {
      var at = cart.attributes;
      if (at && isPast(at['Scheduled Date'])) { at['Scheduled Date'] = ''; at['Scheduled Time'] = ''; }
      (cart.items || []).forEach(function (it) {
        var p = it.properties; if (!p || typeof p !== 'object') return;
        var q = {};
        Object.keys(p).forEach(function (k) {
          var v = p[k];
          if (k.charAt(0) !== '_' && typeof v === 'string' && v.indexOf(', ') > -1) {
            v.split(', ').forEach(function (x, i) { q[i ? k + ' (' + (i + 1) + ')' : k] = x; });
          } else q[k] = v;
        });
        if (p._note && !q['Special Instructions']) q['Special Instructions'] = p._note;
        it.properties = q;
      });
      return new Response(JSON.stringify(cart), { status: r.status, statusText: r.statusText, headers: { 'Content-Type': 'application/json' } });
    }).catch(function () { return r; });
  }
  /* R60 (Oct 27 2026): Checkmate does not pass Shopify's scheduled time to Toast (every Shopify order
     arrives with no due time, so a next-day order fires to the kitchen right away, e.g. CGW#3790).
     Until Checkmate maps it, the scheduled time is written as the FIRST line of the order note, which
     prints on the Toast ticket: "SCHEDULED DELIVERY: Tue, Oct 27, 12:00 PM. DO NOT MAKE NOW". */
  var SCHED_RE = /^SCHEDULED (PICKUP|DELIVERY|CATERING[^:]*):.*$/;
  function schedLine(a) {
    if (!a) return '';
    var type = String(a['Order Type'] || '');
    var label = '';
    if (a['Catering Order'] === 'Yes' || /Catering/i.test(type)) {
      if (a['Scheduled Date']) label = a['Scheduled Date'] + (a['Scheduled Time'] ? ' ' + a['Scheduled Time'] : '');
      if (label) return 'SCHEDULED ' + (/Delivery/i.test(type) ? 'CATERING DELIVERY' : 'CATERING PICKUP') + ': ' + label + '. DO NOT MAKE NOW';
      return '';
    }
    var rt = String(a['Requested Time'] || '');
    if (!rt || /^ASAP$/i.test(rt)) return '';
    return 'SCHEDULED ' + (/Delivery/i.test(type) ? 'DELIVERY' : 'PICKUP') + ': ' + rt + '. DO NOT MAKE NOW';
  }
  var schedBusy = false;
  function syncSchedNote() {
    if (schedBusy) return Promise.resolve();
    schedBusy = true;
    return of.call(window, '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var want = schedLine(cart.attributes);
      var lines = String(cart.note || '').split('\n').filter(function (l) { return l && !SCHED_RE.test(l); });
      if (want) lines.unshift(want);
      var note = lines.join('\n').slice(0, 1000);
      if (note === String(cart.note || '')) return;
      return of.call(window, '/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note }) });
    }).catch(function () {}).then(function () { schedBusy = false; });
  }
  var wrapped = function (input, init) {
    var isAdd = false, isAttr = false;
    try {
      var u0 = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/update(\.js)?(\?|$)/.test(u0) && init && typeof init.body === 'string' && init.body.indexOf('"attributes"') > -1) isAttr = true;
    } catch (e) {}
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string' && init.body.charAt(0) === '{') {
        var b = JSON.parse(init.body);
        (b.items || (b.id ? [b] : [])).forEach(function (it) { swapVariant(it); fixItem(it, titleFor(it)); });
        init = Object.assign({}, init, { body: JSON.stringify(b) });
        isAdd = true;
      }
    } catch (e) {}
    var res = of.call(this, input, init);
    if (isAdd) return res.then(function (r) { return flushNotes().then(syncSchedNote).then(function () { return r; }); });
    if (isAttr) return res.then(function (r) { syncSchedNote(); return r; });
    if (isCartRead(input, init)) return res.then(readBack).catch(function () { return res; });
    return res;
  };
  wrapped.__cgprops = true;
  window.fetch = wrapped;
})();
